import * as React from 'react';
import { FC } from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import { isUndefined } from 'lodash-es';
import { useIntl } from 'react-intl';

import { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';

import { GreetingVariant } from '../loyalty-widgets';

import {
  Balance,
  CTAWrapper,
  GreetingWrapper,
  JoinNowCTA,
  JoinNowContainer,
  StyledLoyaltyRewardsLogo as LoyaltyRewardsLogo,
  P,
  PointBalancePointsIcon,
  PointText,
  PointsWrapper,
  StyledLoadingAnimation,
  TextContainer,
  Wrapper,
} from './loyalty-cta-bar.styled';
import { ICtaContent, ILoyaltyCtaBarViewProps, IPointsContent } from './types';

const PointsContent: FC<IPointsContent> = ({ points, loading, hideLoyaltyLogo }) => (
  <PointsWrapper>
    {!hideLoyaltyLogo && <LoyaltyRewardsLogo data-testid="loyalty-rewards-logo" inverted={true} />}
    {!loading && (
      <Balance>
        <PointBalancePointsIcon />
        <PointText>{points}</PointText>
        <Icon icon="next" color="white" width="16px" aria-hidden />
      </Balance>
    )}
  </PointsWrapper>
);

const CtaContent: FC<ICtaContent> = ({ formatMessage, handleClick }) => (
  <JoinNowContainer>
    <PointBalancePointsIcon />
    <TextContainer>
      <P data-testid="earn-points">{formatMessage({ id: 'earnPoints' })} -</P>
      <JoinNowCTA
        size={ActionButtonSizes.SMALL}
        variant={ActionButtonVariants.TEXT_ONLY}
        onClick={handleClick}
      >
        {formatMessage({ id: 'joinNow' })}
      </JoinNowCTA>
    </TextContainer>
  </JoinNowContainer>
);

export const LoyaltyCtaBarViewBase: FC<ILoyaltyCtaBarViewProps> = ({
  handleClick,
  points,
  loading = true,
  hideLoyaltyLogo = false,
}) => {
  const { formatMessage } = useIntl();
  const showCTAContent = loading || !isUndefined(points);

  return (
    <Wrapper onClick={handleClick} data-testid="loyalty-cta-bar">
      {showCTAContent ? (
        <>
          <PointsContent points={points} loading={loading} hideLoyaltyLogo={hideLoyaltyLogo} />
          {loading ? (
            <StyledLoadingAnimation />
          ) : (
            <GreetingWrapper variant={GreetingVariant.TEXT} dayPeriodEnabled={false} />
          )}
        </>
      ) : (
        <CTAWrapper>
          {!hideLoyaltyLogo && <LoyaltyRewardsLogo inverted={true} />}
          <CtaContent formatMessage={formatMessage} handleClick={handleClick} />
        </CTAWrapper>
      )}
    </Wrapper>
  );
};
